import { render, staticRenderFns } from "./Classes.vue?vue&type=template&id=55ba23e4"
import script from "./Classes.vue?vue&type=script&lang=js"
export * from "./Classes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports